/* eslint-disable react/require-default-props */
import React, { FC, useRef, useEffect } from 'react';

interface IProps {
    color: string;
    icon: string;
    isChecked: boolean;
    labelId: string;
    onClick?: (arg: any) => void;
    onKeyDown?: (arg: any) => void;
    isFocused?: boolean;
}

// TODO: change to font awesome icons
const Checkbox: FC<IProps> = ({ color, icon, isChecked, labelId, onClick = null, onKeyDown = null, isFocused = false }) => {
    const ref = useRef(null);

    useEffect(() => {
        if (isFocused && ref && ref.current) {
            ref.current.focus();
        }
    }, [isFocused, ref]);

    return (
        <div
            className="checkbox-component"
            style={{ padding: 0, height: 20, cursor: 'pointer', border: 'none' }}
            onClick={onClick}
            onKeyDown={onKeyDown}
            data-test-id={`${icon}-checkbox`}
            role="checkbox"
            tabIndex={0}
            aria-checked={isChecked}
            aria-labelledby={labelId}
            ref={ref}
        >
            <i data-test-id="checkbox-icon" className="material-icons" style={{ fontSize: 20, color }}>
                {icon}
            </i>
        </div>
    );
}

export default Checkbox;
